import React from 'react'
import './Icon.scss'
const rootClassName = 'icon-component'

export const AddIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M24 12C24 5.37129 18.6287 0 12 0C5.37129 0 0 5.37129 0 12C0 14.0388 0.509249 16.0045 1.46771 17.7543C2.20618 19.1018 3.1944 20.2953 4.37466 21.2658C6.50667 23.0227 9.17895 24 12 24C18.6287 24 24 18.6287 24 12ZM1.5 12C1.5 6.19971 6.19971 1.5 12 1.5C17.8003 1.5 22.5 6.19971 22.5 12C22.5 17.8003 17.8003 22.5 12 22.5C9.53024 22.5 7.19438 21.6458 5.32797 20.1077C4.29496 19.2583 3.42979 18.2134 2.7832 17.0336C1.9451 15.5035 1.5 13.7854 1.5 12ZM11.25 11.25H5.81212C5.3979 11.25 5.06212 11.5858 5.06212 12C5.06212 12.4142 5.3979 12.75 5.81212 12.75H11.25L11.25 18.1879C11.25 18.6021 11.5858 18.9379 12 18.9379C12.4142 18.9379 12.75 18.6021 12.75 18.1879L12.75 12.75L18.1879 12.75C18.6021 12.75 18.9379 12.4142 18.9379 12C18.9379 11.5858 18.6021 11.25 18.1879 11.25L12.75 11.25V5.81212C12.75 5.3979 12.4142 5.06212 12 5.06212C11.5858 5.06212 11.25 5.3979 11.25 5.81212V11.25Z'
      />
    </svg>
  )
}
